module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isProfileFilled) ? _c('md-layout', {
    staticClass: "exp_choice",
    staticStyle: {
      "flex": "0 1 auto"
    },
    attrs: {
      "md-gutter": "",
      "md-column": "",
      "md-vertical-align": "start"
    }
  }, [_c('md-layout', {
    staticStyle: {
      "flex": "0 1 0%",
      "margin": "50px 0"
    }
  }, [_c('h2', {}, [_vm._v("CHOOSE THE TYPE OF EXPERIMENT")])]), _vm._v(" "), _c('md-layout', [_c('md-layout', {
    staticClass: "l_choice",
    attrs: {
      "md-align": "center"
    }
  }, [_c('img', {
    staticClass: "choice_icon",
    staticStyle: {
      "width": "245px",
      "height": "115px"
    },
    attrs: {
      "src": require("../assets/like_icons.png")
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "choice_text md-body-1"
  }, [_vm._v("\n     \n     In this experiment you'll have to put likes\\dislikes based on your perception of the molecule. \n     You can have multiple criterions but try just to give the overall impression of the molecule you see. "), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n     You'll have 5 seconds on each molecule\n     \n     ")]), _vm._v(" "), _c('md-button', {
    staticClass: "choice_button like_button",
    on: {
      "click": _vm.gotoExperimentLike
    }
  }, [_vm._v("\n       LIKE OR DISIKE\n     ")])], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "l_choice",
    attrs: {
      "md-align": "center"
    }
  }, [_c('img', {
    staticClass: "choice_icon",
    staticStyle: {
      "width": "245px",
      "height": "115px"
    },
    attrs: {
      "src": require("../assets/human_gan_icons.png")
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "choice_text md-body-1"
  }, [_vm._v("\n     In this experiment you'll have to distinguish human and GAN designed molecules. \n     Make your decision wisely as it's not that easy to tell one from another. \n     Try to beat AI and guess as much as possible. "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" \n     You'll have 5 seconds on each molecule   \n     ")]), _vm._v(" "), _c('md-button', {
    staticClass: "choice_button hg_button",
    on: {
      "click": _vm.gotoExperimentGan
    }
  }, [_vm._v("\n       HUMAN OR GAN\n     ")])], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "l_choice",
    attrs: {
      "md-align": "center"
    }
  }, [_c('img', {
    staticClass: "choice_icon",
    staticStyle: {
      "width": "95px",
      "height": "115px"
    },
    attrs: {
      "src": require("../assets/emotiv_icon.png")
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "choice_text md-body-1"
  }, [_vm._v("\n     Use EMOTIV device to record emotions that each molecule evokes in you.\n     We'll record your EEG, facial expression and will track your glance."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n     You'll have 5 seconds on each molecule \n     ")]), _vm._v(" "), _c('md-button', {
    staticClass: "choice_button emotiv_button",
    on: {
      "click": _vm.gotoExperimentCortex
    }
  }, [_vm._v("\n       EMOTIVE EEG\n     ")])], 1)], 1)], 1) : _c('md-layout', {
    staticClass: "exp_choice",
    attrs: {
      "md-align": "center"
    }
  }, [_c('h2', [_vm._v("PLEASE FILL IN "), _c('router-link', {
    attrs: {
      "to": "profile"
    }
  }, [_vm._v("PROFILE")]), _vm._v(" FORM TO START THE EXPERIMENT")], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7f05a94b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ExperimentChoice.vue
// module id = 341
// module chunks = 1